// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./core-dms/static/css/reset.css
// module id = 219
// module chunks = 96 97 98 99